export default {
  navigate: (context, payload) => {
    const { commit } = context
    commit('setNavigation', payload)
  },
}
